import React from "react";
import moment from "moment";
import global from "../../../common/utility/global";
import {
  Modal,
  Divider,
  Input,
  Form,
  Select,
  Icon,
  DatePicker,
  Tabs,
  Button,
  Row,
  Col,
} from "antd";
import {
  FORMAT_2DECIMALS,
  FORMAT_3DECIMALS,
  GREATER_THAN_ZERO,
} from "../../../common/types/regularExpresionType";
const { TabPane } = Tabs;
const { Option } = Select;

class FormModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log(values);
      if (!err) {
        const form = {
          id: values.id,
          fechaStr: values.fechaStr.format("DD/MM/YYYY"),
          compraComercial: parseFloat(values.compraComercial ?? 0),
          ventaComercial: parseFloat(values.ventaComercial ?? 0)
        };
        this.props.onSave(form, this.props.form);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    getFieldDecorator("id", { initialValue: this.props.formValues.id });
    return (
      <Modal
        title={
          this.props.formValues.id === 0
            ? "Registrar Tipo de Cambio"
            : "Modificar Tipo de Cambio"
        }
        visible={this.props.visible}
        cancelText={"Cancelar"}
        okText={"Guardar"}
        onCancel={this.handleCancel}
        onOk={this.handleOk}
        style={{ top: 30 }}
      >
        <Form>
          <Row gutter={16}>
            <Col className="gutter-row" span={24}>
              <Form.Item label="Fecha">
                {getFieldDecorator("fechaStr", {
                  initialValue: moment(
                    this.props.formValues.fechaStr,
                    "DD/MM/YYYY"
                  ),
                  rules: [
                    {
                      type: "object",
                      required: true,
                      message: "Requerido",
                    },
                  ],
                })(
                  <DatePicker
                    className="first-input"
                    placeholder="Seleccione fecha"
                    prefix={
                      <Icon
                        type="filter"
                        style={{ color: "rgba(0,0,0,.25)" }}
                      />
                    }
                    format="DD/MM/YYYY"
                  />
                )}
              </Form.Item>
            </Col>
          </Row>

          <Divider orientation="left">SUNAT</Divider>

          <Row gutter={16}>
                <Col className="gutter-row" span={12}>
                  <Form.Item label="Compra">
                    {getFieldDecorator("compra", {
                      initialValue: parseFloat(
                        this.props.formValues.compra
                      ).toFixed(3)
                    })(
                      <Input
                        disabled={true}
                        className="text-right"
                        placeholder="Ingresar compra"
                        autoComplete="off"
                        onKeyPress={global.onKeyPressDecimals}
                        onBlur={(e) => {
                          this.props.form.setFieldsValue({
                            peso: global.onBlurDecimals(e, 3),
                          });
                        }}
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={12}>
                  <Form.Item label="Venta">
                    {getFieldDecorator("venta", {
                      initialValue: parseFloat(
                        this.props.formValues.venta
                      ).toFixed(3)
                    })(
                      <Input
                        disabled={true}
                        className="text-right"
                        placeholder="Ingresar venta"
                        autoComplete="off"
                        onKeyPress={global.onKeyPressDecimals}
                        onBlur={(e) => {
                          this.props.form.setFieldsValue({
                            peso: global.onBlurDecimals(e, 3),
                          });
                        }}
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
           
          <Divider orientation="left">COMERCIAL</Divider>

          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <Form.Item label="Compra">
                {getFieldDecorator("compraComercial", {
                  initialValue: parseFloat(
                    this.props.formValues.compraComercial
                  ).toFixed(3),
                  rules: [
                    {
                      pattern: new RegExp(FORMAT_3DECIMALS),
                      message: "Formato decimal incorrecto (0.000)",
                    },
                    {
                        required: true,
                        pattern: new RegExp(GREATER_THAN_ZERO),
                        message: "Ingrese un valor mayor a 0.000"
                    }
                  ],
                })(
                  <Input
                    className="text-right"
                    placeholder="Ingresar compra"
                    autoComplete="off"
                    onKeyPress={global.onKeyPressDecimals}
                    onBlur={(e) => {
                      this.props.form.setFieldsValue({
                        compraComercial: global.onBlurDecimals(e, 3),
                      });
                    }}
                  />
                )}
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={12}>
              <Form.Item label="Venta">
                {getFieldDecorator("ventaComercial", {
                  initialValue: parseFloat(
                    this.props.formValues.ventaComercial
                  ).toFixed(3),
                  rules: [
                    {
                      pattern: new RegExp(FORMAT_3DECIMALS),
                      message: "Formato decimal incorrecto (0.000)",
                    },
                    {
                        required: true,
                        pattern: new RegExp(GREATER_THAN_ZERO),
                        message: "Ingrese un valor mayor a 0.000"
                    }
                  ],
                })(
                  <Input
                    className="text-right"
                    placeholder="Ingresar venta"
                    autoComplete="off"
                    onKeyPress={global.onKeyPressDecimals}
                    onBlur={(e) => {
                      this.props.form.setFieldsValue({
                        ventaComercial: global.onBlurDecimals(e, 3),
                      });
                    }}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(FormModal);
